const data = {
  id: 1,
  title: 'Choose the word that has the underlined part pronounced differently from the rest.',
  subTitle: 'Chọn từ có phần gạch chân phát âm khác so với các từ còn lại.',
  audioUrl: '',
  answers: [
    { id: 1, answer: 'visited', isCorrect: true },
    { id: 2, answer: 'learned', isCorrect: false },
    { id: 3, answer: 'played', isCorrect: false },
  ],
  settings: {
    answers: {
      direction: 'horizontal',
      bulletType: 'none',
      // bulletType: 'character',
      // bulletType: 'number',
      underlined: true,
    },
  },
};

export default data;
